/* ************************** Import Packages *************************** **/
import React from "react";

const ButtonLoader = () => {
  return (
    <>
      <span
        className="spinner-border spinner-border-sm ml-2"
        role="status"
        aria-hidden="false"
        style={{ backgroundColor: "none", width: "1rem", height: "1rem", flexShrink: 0 }}
      />
    </>
  );
};

export default ButtonLoader;
